var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import s from './styles.module.css.json';
export var FormLabel = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, htmlFor = _a.htmlFor, code = _a.code, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, otherProps = __rest(_a, ["children", "className", "htmlFor", "code", "required", "error"]);
    var classNames = cn(s.formLabel, className, (_b = {},
        _b[s['formLabel--error']] = error,
        _b));
    return (React.createElement("label", __assign({ className: classNames, htmlFor: htmlFor }, otherProps),
        React.createElement("span", { className: s.formLabel__label },
            children,
            required && React.createElement("span", { className: s.formLabel__required }, "*")),
        code && React.createElement("span", { className: s.formLabel__code }, code)));
};
//# sourceMappingURL=index.js.map